import { normalizeNumber } from '../../../utils/amountUtils';
import {
  VOUCHER_TYPE_DOLLAR,
  VOUCHER_INPUT_FIXED,
  VOUCHER_TYPE_PERCENTAGE,
  VOUCHER_INPUT_PERCENTAGE,
  VOUCHER_TYPE_CUSTOM,
  VOUCHER_INPUT_CUSTOM,
  VOUCHER_MAX_CHAR_LENGTH,
} from './voucherConstants';
import get from 'lodash/get';

export const isGmbFlow = (bn) => {
  return bn && bn.toLowerCase() === 'gmb';
};

export const isGenericFlow = (bn) => {
  return !isGmbFlow(bn);
};

export const isInputTextValid = (inputToTest) => {
  // valid if character does not matches '<' '>' - to validate against scripting
  return inputToTest.match('^[^<>]*$');
};

export const isVoucherAmountInRange = (stringToTest, allowDecimals = true) => {
  // checks for value between 1 and 100,
  // & optionally allows for decimal numbers with up to 2 decimals
  const decimalsRegexPattern = '(\\.?|(\\.[0-9]{1,2})?)';
  const valueBetweenOand100Pattern = `^([1-9][0-9]?)${
    allowDecimals ? decimalsRegexPattern : ''
  }$|^100$`;
  const valueWithInLimit = new RegExp(valueBetweenOand100Pattern);
  // normalize number to en-US to do regex strict regex validation
  const normalizedNumber = normalizeNumber(stringToTest);
  return !isNaN(normalizedNumber) && valueWithInLimit.test(normalizedNumber);
};

export const areVoucherDetailsComplete = (
  voucherInfo,
  selectedVoucherDetails,
  postalCodeValidationPattern,
  isZipcodeRequired
) => {
  const { zipcode, isOnAgreement } = voucherInfo;
  const { value, details, type } = selectedVoucherDetails;
  const validZipCode = zipcode && zipcode.match(postalCodeValidationPattern);
  const validTagLine =
    value &&
    ((!isNaN(parseFloat(value, 10)) &&
      isVoucherAmountInRange(
        value,
        type === VOUCHER_TYPE_PERCENTAGE ? false : true
      )) ||
      (isNaN(parseFloat(value, 10)) && value.length < VOUCHER_MAX_CHAR_LENGTH));
  const validDetails =
    !details || (details && details.length <= VOUCHER_MAX_CHAR_LENGTH);
  return (
    validTagLine &&
    validDetails &&
    (validZipCode || !isZipcodeRequired) &&
    isOnAgreement
  );
};

export const voucherTypeToInputTypeMapping = [
  {
    voucherType: VOUCHER_TYPE_DOLLAR,
    voucherInputType: VOUCHER_INPUT_FIXED,
  },
  {
    voucherType: VOUCHER_TYPE_PERCENTAGE,
    voucherInputType: VOUCHER_INPUT_PERCENTAGE,
  },
  {
    voucherType: VOUCHER_TYPE_CUSTOM,
    voucherInputType: VOUCHER_INPUT_CUSTOM,
  },
];

export const getVoucherDetail = (button) => {
  const voucherAdded = !!get(button, 'offerProgram');
  if (voucherAdded) {
    const { type, value } = get(
      button,
      'offerProgram.computation_rules[0].offer_value'
    );
    const { description: voucherDetails, sub_title: discountTagline } = get(
      button,
      'offerProgram.localized_attributes[0]'
    );
    const voucherType = voucherTypeToInputTypeMapping.find((vType) => {
      let voucherInputType = VOUCHER_INPUT_PERCENTAGE;
      if (type !== VOUCHER_INPUT_PERCENTAGE) {
        voucherInputType =
          value === 0 ? VOUCHER_INPUT_CUSTOM : VOUCHER_INPUT_FIXED;
      }
      return vType.voucherInputType === voucherInputType;
    }).voucherType;
    let voucherValue = discountTagline;
    if (value !== 0) {
      voucherValue = type === VOUCHER_INPUT_FIXED ? value / 100 : value;
    }

    return {
      voucherType,
      voucherValue,
      voucherDetails,
      discountTagline,
    };
  }

  return {};
};

export const getAllVoucherTypeInfo = (voucherDetail, state = {}) => {
  const { voucherType, voucherValue, voucherDetails, discountTagline } =
    voucherDetail;
  const allVoucherTypeInfo = [
    { type: VOUCHER_TYPE_DOLLAR },
    { type: VOUCHER_TYPE_PERCENTAGE },
    { type: VOUCHER_TYPE_CUSTOM },
  ];
  const typeToUpdate = voucherType || state.selectedVoucherType;
  const voucherInfoIndexToUpdate = allVoucherTypeInfo.findIndex(
    (voucherInfo) => voucherInfo?.type === typeToUpdate
  );
  const updatedVoucherInfo = allVoucherTypeInfo[voucherInfoIndexToUpdate] || {};
  if (voucherValue !== undefined) {
    updatedVoucherInfo.value = voucherValue;
    updatedVoucherInfo.tagline =
      typeToUpdate === VOUCHER_TYPE_CUSTOM ? voucherValue : discountTagline;
  }

  if (voucherDetails !== undefined) {
    updatedVoucherInfo.details = voucherDetails;
  }

  allVoucherTypeInfo.splice(voucherInfoIndexToUpdate, 1, updatedVoucherInfo);

  return allVoucherTypeInfo;
};
